@if (configuration && { gridSize: gridSize$ | async }) {
    <section
        class="nw-key-topic-one-block__container"
        [class.nw-key-topic-one-block__container--bordered]="configuration.border"
        [class.nw-key-topic-one-block__container--shadow]="
            !!configuration.background && configuration.shadow !== false
        "
        [style.gridTemplateColumns]="'repeat(' + maxGridSize + ', 1fr)'"
        [style.gridTemplateRows]="
            'repeat(' +
            ((maxGridSize || 0) + (!!configuration.title ? 1 : 0)) +
            ', min-content)'
        "
        [class.nw-key-topic-one-block__container--single-dark]="
            configuration.content.length === 1 &&
            configuration.content[0].scheme === 'dark'
        "
        [class.nw-key-topic-one-block__container--double-light]="
            configuration.content.length === 2 &&
            configuration.content[0].scheme === 'light'
        "
        [class.nw-key-topic-one-block__container--contains-media]="containsMedia"
        [class]="'nw-key-topic-one-block__container--' + configuration.content.length"
    >
        @if (configuration.title; as title) {
            @if (title.content) {
                @switch (title.type || 1) {
                    @case (1) {
                        <h1
                            class="nw-key-topic-one-block__container__title"
                            [style.gridColumnStart]="title.columnStart || 1"
                            [style.gridColumnEnd]="
                                !!title.columnEnd
                                    ? ((title.columnEnd || 0) > (maxGridSize || 0)
                                          ? maxGridSize || 0
                                          : title.columnEnd || 0) + 1
                                    : (maxGridSize || 0) + 1
                            "
                            [style.textAlign]="title.alignment"
                        >
                            {{ title.content }}
                        </h1>
                    }
                    @case (2) {
                        <h2
                            class="nw-key-topic-one-block__container__title"
                            [style.gridColumnStart]="title.columnStart || 1"
                            [style.gridColumnEnd]="
                                !!title.columnEnd
                                    ? ((title.columnEnd || 0) > (maxGridSize || 0)
                                          ? maxGridSize || 0
                                          : title.columnEnd || 0) + 1
                                    : (maxGridSize || 0) + 1
                            "
                            [style.textAlign]="title.alignment"
                        >
                            {{ title.content }}
                        </h2>
                    }
                    @case (3) {
                        <h3
                            class="nw-key-topic-one-block__container__title"
                            [style.gridColumnStart]="title.columnStart || 1"
                            [style.gridColumnEnd]="
                                !!title.columnEnd
                                    ? ((title.columnEnd || 0) > (maxGridSize || 0)
                                          ? maxGridSize || 0
                                          : title.columnEnd || 0) + 1
                                    : (maxGridSize || 0) + 1
                            "
                            [style.textAlign]="title.alignment"
                        >
                            {{ title.content }}
                        </h3>
                    }
                    @case (4) {
                        <h4
                            class="nw-key-topic-one-block__container__title"
                            [style.gridColumnStart]="title.columnStart || 1"
                            [style.gridColumnEnd]="
                                !!title.columnEnd
                                    ? ((title.columnEnd || 0) > (maxGridSize || 0)
                                          ? maxGridSize || 0
                                          : title.columnEnd || 0) + 1
                                    : (maxGridSize || 0) + 1
                            "
                            [style.textAlign]="title.alignment"
                        >
                            {{ title.content }}
                        </h4>
                    }
                }
            }
        }

        @if (configuration.subTitle; as subtitle) {
            @if (subtitle.content) {
                <p
                    class="nw-key-topic-one-block__container__subtitle"
                    [style.gridColumnStart]="subtitle.columnStart || 1"
                    [style.gridColumnEnd]="
                        !!subtitle.columnEnd
                            ? (subtitle.columnEnd > (maxGridSize || 0)
                                  ? maxGridSize || 0
                                  : subtitle.columnEnd) + 1
                            : (maxGridSize || 0) + 1
                    "
                >
                    {{ subtitle.content }}
                </p>
            }
        }

        @for (
            content of configuration.content;
            track content.content;
            let index = $index
        ) {
            @if (configuration.content) {
                @if (content.blockLink) {
                    <a
                        class="nw-key-topic-one-block__container__col nw-key-topic-one-block__container__col--anchor"
                        [class.nw-key-topic-one-block__container__col--only-content]="
                            !content.button?.label && !content.image?.path
                        "
                        [class.nw-key-topic-one-block__container__col--4]="
                            !content.button?.label &&
                            !content.image?.path &&
                            configuration.content.length === 4
                        "
                        [class.padding-left-xl]="configuration.content.length === 1"
                        [class.padding-right-xl]="configuration.content.length === 1"
                        [class.padding-bottom-xl]="configuration.content.length === 1"
                        [class.padding-left-none]="
                            configuration.background === undefined &&
                            content.scheme === undefined
                        "
                        [class.padding-right-none]="
                            configuration.background === undefined &&
                            content.scheme === undefined
                        "
                        [style.gridRowStart]="
                            content.rowStart ||
                            (!!configuration.title ? 1 : 0) +
                                (!!configuration.subTitle ? 1 : 0) +
                                Ceil(
                                    configuration.content.length % 4 === 0
                                        ? (index + 1) / 4
                                        : configuration.content.length % 3 === 0
                                          ? (index + 1) / 3
                                          : configuration.content.length % 2 === 0
                                            ? (index + 1) / 2
                                            : (index + 1) / 4
                                )
                        "
                        [style.gridRowEnd]="
                            content.rowEnd ||
                            (!!configuration.title ? 1 : 0) +
                                (!!configuration.subTitle ? 1 : 0) +
                                Ceil(
                                    configuration.content.length % 4 === 0
                                        ? (index + 1) / 4
                                        : configuration.content.length % 3 === 0
                                          ? (index + 1) / 3
                                          : configuration.content.length % 2 === 0
                                            ? (index + 1) / 2
                                            : (index + 1) / 4
                                )
                        "
                        [style.gridColumnStart]="
                            content.columnStart ||
                            ($last &&
                            configuration.content.length % 4 !== 0 &&
                            configuration.content.length % 3 !== 0 &&
                            configuration.content.length % 2 !== 0
                                ? Max([index + 1 - 4, 1])
                                : undefined)
                        "
                        [style.gridColumnEnd]="
                            content.columnEnd ||
                            ($last &&
                            configuration.content.length % 4 !== 0 &&
                            configuration.content.length % 3 !== 0 &&
                            configuration.content.length % 2 !== 0
                                ? -1
                                : undefined)
                        "
                        [style.minHeight.px]="
                            content.image &&
                            content.image.height === '100%' &&
                            content.image.width === '100%'
                                ? 300
                                : undefined
                        "
                        [class.nw-key-topic-one-block__container__col--dark]="
                            content.scheme === 'dark'
                        "
                        [class.nw-key-topic-one-block__container__col--light]="
                            content.scheme === 'light'
                        "
                        [class.padding-none]="content.image?.padding === false"
                        [class.nw-key-topic-one-block__container__col--block-link]="
                            content?.blockLink
                        "
                        [class.nw-key-topic-one-block__container__col--centered]="
                            centered
                        "
                        tabindex="-1"
                        [href]="content.blockLink"
                        [style.justifyContent]="content.justifyContent || 'center'"
                    >
                        <ng-container
                            *ngTemplateOutlet="
                                contentTemplate;
                                context: { $implicit: content, index: index }
                            "
                        ></ng-container>
                    </a>
                } @else {
                    <div
                        class="nw-key-topic-one-block__container__col"
                        [class.nw-key-topic-one-block__container__col--only-content]="
                            !content.button?.label && !content.image?.path
                        "
                        [class.nw-key-topic-one-block__container__col--4]="
                            !content.button?.label &&
                            !content.image?.path &&
                            configuration.content.length === 4
                        "
                        [class.padding-left-xl]="configuration.content.length === 1"
                        [class.padding-right-xl]="configuration.content.length === 1"
                        [class.padding-bottom-xl]="configuration.content.length === 1"
                        [class.padding-left-none]="
                            configuration.background === undefined &&
                            content.scheme === undefined
                        "
                        [class.padding-right-none]="
                            configuration.background === undefined &&
                            content.scheme === undefined
                        "
                        [style.gridRowStart]="
                            content.rowStart ||
                            (!!configuration.title ? 1 : 0) +
                                (!!configuration.subTitle ? 1 : 0) +
                                Ceil(
                                    configuration.content.length % 4 === 0
                                        ? (index + 1) / 4
                                        : configuration.content.length % 3 === 0
                                          ? (index + 1) / 3
                                          : configuration.content.length % 2 === 0
                                            ? (index + 1) / 2
                                            : (index + 1) / 4
                                )
                        "
                        [style.gridRowEnd]="
                            content.rowEnd ||
                            (!!configuration.title ? 1 : 0) +
                                (!!configuration.subTitle ? 1 : 0) +
                                Ceil(
                                    configuration.content.length % 4 === 0
                                        ? (index + 1) / 4
                                        : configuration.content.length % 3 === 0
                                          ? (index + 1) / 3
                                          : configuration.content.length % 2 === 0
                                            ? (index + 1) / 2
                                            : (index + 1) / 4
                                )
                        "
                        [style.gridColumnStart]="
                            content.columnStart ||
                            ($last &&
                            configuration.content.length % 4 !== 0 &&
                            configuration.content.length % 3 !== 0 &&
                            configuration.content.length % 2 !== 0
                                ? Max([index + 1 - 4, 1])
                                : undefined)
                        "
                        [style.gridColumnEnd]="
                            content.columnEnd ||
                            ($last &&
                            configuration.content.length % 4 !== 0 &&
                            configuration.content.length % 3 !== 0 &&
                            configuration.content.length % 2 !== 0
                                ? -1
                                : undefined)
                        "
                        [style.minHeight.px]="
                            content.image &&
                            content.image.height === '100%' &&
                            content.image.width === '100%'
                                ? 300
                                : undefined
                        "
                        [class.nw-key-topic-one-block__container__col--dark]="
                            content.scheme === 'dark'
                        "
                        [class.nw-key-topic-one-block__container__col--light]="
                            content.scheme === 'light'
                        "
                        [class.padding-none]="content.image?.padding === false"
                        [class.nw-key-topic-one-block__container__col--block-link]="
                            content?.blockLink
                        "
                        [class.nw-key-topic-one-block__container__col--centered]="
                            centered
                        "
                        tabindex="-1"
                        [style.justifyContent]="content.justifyContent || 'center'"
                    >
                        <ng-container
                            *ngTemplateOutlet="
                                contentTemplate;
                                context: { $implicit: content, index: index }
                            "
                        ></ng-container>
                    </div>
                }
            }
        }

        @if (configuration.callToAction; as callToAction) {
            @if (callToAction.path) {
                <div
                    class="nw-key-topic-one-block__container__calltoaction"
                    [style.gridColumnStart]="1"
                    [style.gridColumnEnd]="(maxGridSize || 0) + 1"
                    [style.gridRowStart]="(maxRow || 0) + 1"
                    [style.gridRowEnd]="(maxRow || 0) + 1"
                >
                    <a [href]="callToAction.path" class="nw-button">
                        {{ callToAction.label }}

                        <nw-icon
                            class="nw-key-topic-one-block__container__calltoaction__icon"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill
                                viewBox="0 0 13 22"
                                height="13"
                                width="22"
                                preserveAspectRatio="xMidYMid meet"
                                focusable="false"
                            >
                                <path
                                    fill="currentColor"
                                    d="M12.06 9.94a1.502 1.502 0 0 1 0 2.124l-9 9a1.502 1.502 0 0 1-2.124-2.123L8.876 11 .942 3.06A1.502 1.502 0 0 1 3.064.935l9 9-.005.005Z"
                                />
                            </svg>
                        </nw-icon>
                    </a>
                </div>
            }
        }
    </section>

    <div
        class="nw-key-topic-one-block__container__col__img__lightbox"
        tabindex="-1"
        (click)="hideLightbox()"
        (keydown.escape)="hideLightbox()"
    >
        <img nwTint alt="Lightbox image" data-test="lightbox-image" />
    </div>
}

<ng-template #contentTemplate let-content let-index="index">
    @if (
        content.image && content.image.height === '100%' && content.image.width === '100%'
    ) {
        <div
            class="nw-key-topic-one-block__container__col__backdrop"
            [style.backgroundImage]="'url(&quot;' + content.image.path + '&quot;)'"
            [style.backgroundRepeat]="'no-repeat'"
            [style.backgroundSize]="'cover'"
            [style.backgroundPosition]="'50% 50%'"
            nwTint
            [tint]="content.image.tint"
            [id]="'image-tint-' + index"
        ></div>
    }
    @if (content.video; as video) {
        <nw-video
            class="nw-key-topic-one-block__container__col__video"
            [videoUrl]="video.videoUrl"
            [thumbnail]="video.thumbnail"
            [duration]="video.duration"
            [altText]="video.altText"
        ></nw-video>
    }
    @if (content.image; as image) {
        @if (image.path) {
            <img
                [class.nw-key-topic-one-block__container__col__img]="
                    image.height !== '100%' && image.width !== '100%'
                "
                [class.nw-key-topic-one-block__container__col__img--background]="
                    image.height === '100%' && image.width === '100%'
                "
                [class.nw-key-topic-one-block__container__col__img--hover]="
                    image.hover === true || image.link
                "
                [class.nw-key-topic-one-block__container__col__img--lightbox]="
                    image.lightbox === true
                "
                [ngSrc]="image.path"
                [alt]="image.alt"
                priority
                [height]="400"
                [width]="600"
                [style.maxHeight]="image.height || 'inherit'"
                [style.maxWidth]="image.width || '100%'"
                nwTint
                [tint]="image.tint"
                [id]="'image-tint-' + index"
                [class.margin-left-none]="image.margin?.x?.left === 'none'"
                [class.margin-left-auto]="image.margin?.x?.left === 'auto'"
                [class.margin-left-xs]="image.margin?.x?.left === 'xs'"
                [class.margin-left-s]="image.margin?.x?.left === 's'"
                [class.margin-left-m]="image.margin?.x?.left === 'm'"
                [class.margin-left-l]="image.margin?.x?.left === 'l'"
                [class.margin-left-xl]="image.margin?.x?.left === 'xl'"
                [class.margin-right-none]="image.margin?.x?.right === 'none'"
                [class.margin-right-auto]="image.margin?.x?.right === 'auto'"
                [class.margin-right-xs]="image.margin?.x?.right === 'xs'"
                [class.margin-right-s]="image.margin?.x?.right === 's'"
                [class.margin-right-m]="image.margin?.x?.right === 'm'"
                [class.margin-right-l]="image.margin?.x?.right === 'l'"
                [class.margin-right-xl]="image.margin?.x?.right === 'xl'"
                [class.margin-top-none]="image.margin?.y?.top === 'none'"
                [class.margin-top-auto]="image.margin?.y?.top === 'auto'"
                [class.margin-top-xs]="image.margin?.y?.top === 'xs'"
                [class.margin-top-s]="image.margin?.y?.top === 's'"
                [class.margin-top-m]="image.margin?.y?.top === 'm'"
                [class.margin-top-l]="image.margin?.y?.top === 'l'"
                [class.margin-top-xl]="image.margin?.y?.top === 'xl'"
                [class.margin-bottom-none]="image.margin?.y?.bottom === 'none'"
                [class.margin-bottom-auto]="image.margin?.y?.bottom === 'auto'"
                [class.margin-bottom-xs]="image.margin?.y?.bottom === 'xs'"
                [class.margin-bottom-s]="image.margin?.y?.bottom === 's'"
                [class.margin-bottom-m]="image.margin?.y?.bottom === 'm'"
                [class.margin-bottom-l]="image.margin?.y?.bottom === 'l'"
                [class.margin-bottom-xl]="image.margin?.y?.bottom === 'xl'"
                [style.objectFit]="image.objectFit || 'cover'"
                (click)="showLightbox(image, 'image-tint-' + index)"
                (keydown.enter)="showLightbox(image, 'image-tint-' + index)"
            />
        }
    }
    @if (content.content) {
        <div
            class="nw-key-topic-one-block__container__col__content"
            [innerHTML]="content.content | sanitizeHtml"
        ></div>
    }
    @if (content.button; as button) {
        @if (button.label) {
            <div
                class="nw-key-topic-one-block__container__col__button"
                [class.margin-top-auto]="button.margin?.y?.top === 'auto'"
                [class.margin-top-auto]="centered"
            >
                <div
                    [class.nw-key-topic-one-block__container__col__button--link]="
                        button.type === 'link'
                    "
                >
                    <a
                        [href]="button.path"
                        class="nw-key-topic-one-block__container__col__button__link"
                        [class.nw-button]="
                            button.type === 'button' ||
                            button.type === 'outline' ||
                            button.type === 'ghost'
                        "
                        [class.nw-button--primary]="
                            button.type === 'button' ||
                            button.type === 'outline' ||
                            button.type === 'ghost'
                        "
                        [class.nw-button--m]="
                            button.type === 'button' ||
                            button.type === 'outline' ||
                            button.type === 'ghost'
                        "
                        [class.nw-link]="button.type === 'link'"
                        [class.nw-outline-button]="button.type === 'outline'"
                        [class.margin-bottom-none]="
                            (button.type === 'button' ||
                                button.type === 'outline' ||
                                button.type === 'ghost') &&
                            (content.scheme === undefined || content.scheme === 'light')
                        "
                        [class.margin-bottom-xl]="
                            (button.type === 'button' ||
                                button.type === 'outline' ||
                                button.type === 'ghost') &&
                            content.scheme === 'dark'
                        "
                        [class.margin-bottom-m]="button.margin?.y?.bottom === 'm'"
                        [style.float]="button.type === 'ghost' ? 'right' : 'none'"
                        [class.nw-ghost-button]="button.type === 'ghost'"
                        [class.margin-left-auto]="button.margin?.x?.left === 'auto'"
                    >
                        <span [innerHTML]="button.label | sanitizeHtml"></span>

                        <nw-icon
                            class="nw-key-topic-one-block__container__col__button__link__icon"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill
                                viewBox="0 0 13 22"
                                height="13"
                                width="22"
                                preserveAspectRatio="xMidYMid meet"
                                focusable="false"
                            >
                                <path
                                    fill="currentColor"
                                    d="M12.06 9.94a1.502 1.502 0 0 1 0 2.124l-9 9a1.502 1.502 0 0 1-2.124-2.123L8.876 11 .942 3.06A1.502 1.502 0 0 1 3.064.935l9 9-.005.005Z"
                                />
                            </svg>
                        </nw-icon>
                    </a>
                </div>
            </div>
        }
    }
    @if (content.footnote; as footnote) {
        <p
            class="nw-key-topic-one-block__container__col__footnote margin-top-m"
            [innerHTML]="footnote | sanitizeHtml"
        ></p>
    }
</ng-template>
